import React from 'react';
import './App.css';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';

import SideBar from './components/BS-SideBar'

import Login from './pages/Login';
import Index from './pages/Index';
import Users from './pages/Users';
import History from './pages/History';
import Feedback from './pages/Feedback';
import LoginUsers from './pages/LoginUsers';

// Component để bảo vệ route chỉ dành cho admin
function AdminRoute({ component: Component, ...rest }) {
  const userInfo = sessionStorage.getItem('user');
  const currentUser = userInfo ? JSON.parse(userInfo) : null;
  const isAdmin = currentUser && (currentUser.permission === 'admin' || currentUser['permission '] === 'admin');

  return (
    <Route
      {...rest}
      render={(props) =>
        isAdmin ? (
          <Component {...props} />
        ) : (
          <Redirect to="/home" />
        )
      }
    />
  );
}

function App() {
  const isAuthenticated = sessionStorage.getItem('isAuthenticated');
  
  return (
    <BrowserRouter>
      {isAuthenticated ? (
        <div className="d-flex">
          <SideBar />
          <div className="flex-grow-1">
            <Switch>
              <Route exact path="/" render={() => <Redirect to="/home" />} />
              <Route exact path="/home" component={Index} />
              <Route exact path="/users" component={Users} />
              <Route exact path="/history" component={History} />
              <Route exact path="/feedback" component={Feedback} />
              <AdminRoute exact path="/login-users" component={LoginUsers} />
              <Route path="*" render={() => <Redirect to="/home" />} />
            </Switch>
          </div>
        </div>
      ) : (
        <Switch>
          <Route path="*" component={Login} />
        </Switch>
      )}
    </BrowserRouter>
  );
}

export default App;